import clsx from "clsx";
import { FC, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { IDropdownItem } from "@ryde/shared";

import { IRichLogsFilter, RichLogFormFields } from "./rich-logs.models";

interface IRichLogStepDropdown {
  options: IDropdownItem[];
}

export const RichLogStepDropdown: FC<IRichLogStepDropdown> = ({ options }) => {
  const { control } = useFormContext<IRichLogsFilter>();
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = (): void => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (): void => {
    setIsOpen(false);
  };

  return (
    <Controller
      name={RichLogFormFields.step}
      control={control}
      render={({ field }) => (
        <div className="log__filters-sort-dropdown log__filters-sort-dropdown--step">
          <div className="log__filters-sort-row">
            <span className="log__filters-sort-label">Step</span>
            <div className="log__filters-sort-container">
              <button
                type="button"
                className="log__filters-sort-button"
                onClick={handleToggle}
              >
                <div className="log__filters-sort-content">
                  <span className="log__filters-sort-value">
                    {field.value
                      ? options.find(option => option.value === field.value)
                          ?.label || field.value
                      : "All steps"}
                  </span>
                </div>
                <span
                  className={clsx("log__filters-sort-arrow", {
                    open: isOpen,
                  })}
                >
                  ▼
                </span>
              </button>

              {isOpen && (
                <div className="log__filters-sort-dropdown-menu">
                  <button
                    type="button"
                    className={clsx("log__filters-sort-option", {
                      selected: !field.value,
                    })}
                    onClick={() => {
                      field.onChange(undefined);
                      handleSelect();
                    }}
                  >
                    <div className="log__filters-sort-option-content">
                      <span>{"All steps"}</span>
                    </div>
                  </button>
                  {options.map(option => (
                    <button
                      key={option.value}
                      type="button"
                      className={clsx("log__filters-sort-option", {
                        selected: field.value === option.value,
                      })}
                      onClick={() => {
                        field.onChange(option.value);
                        handleSelect();
                      }}
                    >
                      <div className="log__filters-sort-option-content">
                        <span>{option.label}</span>
                      </div>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    />
  );
};
